import { Link } from "react-router-dom";
import type { MediaItem } from "@/types/media";
import { formatViews } from "@/utils/media";
import SectionTitle from "@/components/base/SectionTitle";

export default function HotRanking({ items }: { items: MediaItem[] }) {
  return (
    <div>
      <SectionTitle
        icon="ri-fire-line"
        title="本周热播榜"
        subtitle="基于访问热度模拟生成，看看大家都在追什么"
        moreTo="/category"
      />
      <div className="bg-background-100 rounded-lg p-3 md:p-4">
        <ol className="divide-y divide-background-200">
          {items.map((item, i) => (
            <li key={item.id}>
              <Link
                to={`/detail/${item.id}`}
                className="group flex items-center gap-3 py-3 cursor-pointer"
              >
                <span
                  className={`w-6 text-center font-heading text-lg font-bold shrink-0 ${
                    i < 3 ? "text-accent-500" : "text-foreground-400"
                  }`}
                >
                  {i + 1}
                </span>
                <div className="w-12 h-16 rounded-md overflow-hidden bg-background-200 shrink-0">
                  <img
                    src={item.cover}
                    alt={item.title}
                    title={`${item.title} 水母影视 在线观看`}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="min-w-0 flex-1">
                  <p className="font-medium text-sm md:text-base text-foreground-950 truncate group-hover:text-accent-600 transition-colors">
                    {item.title}
                  </p>
                  <p className="mt-1 text-xs text-foreground-500 flex items-center gap-2 flex-wrap">
                    <span>{item.type}</span>
                    <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
                    <span>{item.year}</span>
                    <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
                    <span>{item.region}</span>
                  </p>
                  <p className="mt-1 text-xs text-foreground-500 flex items-center gap-3">
                    <span className="flex items-center gap-1">
                      <i className="ri-star-fill text-accent-500"></i>
                      {item.rating.toFixed(1)}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-fire-line text-accent-500"></i>
                      {formatViews(item.views)}
                    </span>
                  </p>
                </div>
                <i className="ri-arrow-right-s-line text-foreground-400 group-hover:text-accent-500 transition-colors hidden sm:block"></i>
              </Link>
            </li>
          ))}
        </ol>
      </div>
    </div>
  );
}